'use client';

import { useCallback, useEffect, useRef, useState } from 'react';
import { EntryPoint } from './EntryPoint';
import { useAppDispatch } from '@/hotdesk-ui/hooks/hook';
import { setGeoLocation, toggelLocationPopup } from '@/hotdesk-ui/store/slices/geo-location.slice';
import { fetchRemoteConfig, firebaseAnalytics } from '@/hotdesk-ui/common-classes/firebase.service';
import { RemoteConfigKeys } from '@/hotdesk-ui/enum/remote-keys';
import { Carousel } from '@/hotdesk-ui/enum/listing-workspace';
import { getDefaultLocation } from '@/hotdesk-ui/helpers/location.helper';
import { useRouter } from 'next/navigation';
import { LanguageCode } from '@/hotdesk-ui/constants/langulage.constant';
import { GeoCodeResult } from '@/hotdesk-ui/types/geo-code-result.type';
import { StorageKeys } from '@/hotdesk-ui/enum/storage-keys';
import { storeSet } from '@/hotdesk-ui/helpers/utils';
import { appendExploreLocationParams } from '@/hotdesk-ui/helpers/explore-location-params';
import { getWorkspaceData } from '@/hotdesk-ui/store/slices/listing.slice';
import { setCurrentSearch } from '@/hotdesk-ui/store/slices/search.slice';
import { tracking } from '@/hotdesk-ui/services/tracking.service';
export const EntryPointClietWrapper: React.FC<{
  languageCode: LanguageCode;
}> = ({
  languageCode
}) => {
  const dispatch = useAppDispatch();
  const [listingType, setListingType] = useState<number>(0);
  const autocompleteInput = useRef();
  const autocompleteContainer = useRef();
  const router = useRouter();
  const setCurrentAddress = (address: string) => {
    if (autocompleteInput.current) {
      (autocompleteInput?.current as HTMLInputElement).value = address;
    }
  };
  const [finalOne, setFinalOne] = useState<GeoCodeResult>();
  const getPermission = () => {
    if ('geolocation' in navigator) {
      navigator.permissions.query({
        name: 'geolocation'
      }).then(permissionStatus => {
        if (permissionStatus.state === 'granted') {
          navigator.geolocation.getCurrentPosition(({
            coords
          }) => {
            const {
              latitude,
              longitude
            } = coords;
            getDefaultLocation(latitude, longitude, (result: GeoCodeResult) => {
              setCurrentAddress(result.formatted_address);
              result.lat = latitude;
              result.log = longitude;
              dispatch(setGeoLocation(result));
              dispatch(setCurrentSearch(result));
              dispatch(getWorkspaceData({
                lastSearch: result,
                page: 1
              }));
              storeSet(StorageKeys.GEO_LOCATION_DATA, result);
            });
          });
        } else {
          dispatch(toggelLocationPopup(true));
          monitorPermissionDenied();
        }
      });
    } else {
      monitorPermissionDenied();
    }
  };
  const sentData = () => {
    const params = new URLSearchParams({
      lang: languageCode
    });
    if (!!listingType && listingType != 0) {
      params.set('typeIn', listingType.toString());
      params.set('active', Carousel.listing);
    }
    appendExploreLocationParams(params, finalOne);
    firebaseAnalytics('search_clicked');
    const searchText = autocompleteInput.current ? (autocompleteInput.current as HTMLInputElement).value : '';
    if (searchText) {
      tracking.onSearchEntered(searchText, window.location.href);
    }
    router.push(`/workspaces?${params}`);
  };
  const monitorPermissionDenied = async () => {
    let defaultLocation = (await fetchRemoteConfig(RemoteConfigKeys.DEFAULT_LOCATION, 'object')) as {
      [key: string]: number;
    };
    getDefaultLocation(defaultLocation.latitude, defaultLocation.longitude, (result: GeoCodeResult) => {
      setCurrentAddress(result.formatted_address);
      dispatch(setGeoLocation(result));
      dispatch(setCurrentSearch(result));
      dispatch(getWorkspaceData({
        lastSearch: result,
        page: 1
      }));
      storeSet(StorageKeys.GEO_LOCATION_DATA, result);
    });
  };
  const addFilters = (value: number) => {
    setListingType(value);
  };
  const handlePlaceSelect = useCallback((result: GeoCodeResult) => {
    dispatch(setGeoLocation(result));
    dispatch(setCurrentSearch(result));
    setFinalOne(result);
    tracking.onSearchEntered(result.formatted_address, window.location.href);
  }, [dispatch]);
  useEffect(() => {
    if (!!finalOne) {
      storeSet(StorageKeys.GEO_LOCATION_DATA, finalOne);
    } else {
      getPermission();
    }
    navigator.permissions.query({
      name: 'geolocation'
    }).then(permissionStatus => {
      permissionStatus.onchange = () => {
        getPermission();
      };
    });
  }, []);
  return <EntryPoint autocompleteInput={autocompleteInput} getPermission={getPermission} sentData={sentData} autocompleteContainer={autocompleteContainer} addFilters={addFilters} listingType={listingType} onSelect={handlePlaceSelect} data-sentry-element="EntryPoint" data-sentry-component="EntryPointClietWrapper" data-sentry-source-file="EntryClientWrapper.tsx" />;
};